import { chunk } from 'lodash';
import { useMemo } from 'react';
import { VersionedSnippet } from '@cld/code-snippet-next';
import { getCodeSyntax } from './getCodeSyntax';
import { getDisplayedLanguage } from './getDisplayedLanguage';

export const parseMultiLanguage = (value: string): VersionedSnippet[] => {
  const snippetSources = chunk(value.split(/(?:\r?\n|^)\|(\w+)\r?\n/gm).slice(1), 2);
  return snippetSources.map(([language, snippet]) => ({
    language: getDisplayedLanguage(language),
    versions: [{ snippet, syntax: getCodeSyntax(language) }],
  }));
};

export const parseDefinedLanguage = (snippet: string, language: string): VersionedSnippet[] => [
  {
    language,
    versions: [{ snippet, syntax: getCodeSyntax(language) }],
  },
];

const MULTI_LANGUAGE = 'multi';

/**
 * A hook that returns array of snippets based on specified language
 * It supports 'multi' language
 */
export const useParsedSnippets = (value: string, language: string) =>
  useMemo(() => (language === MULTI_LANGUAGE ? parseMultiLanguage(value) : parseDefinedLanguage(value, language)), [language, value]);
